import { useEffect } from 'react';

interface Props {
  onComplete: () => void;
}

/**
 * Full-screen glitch flash that plays when the login icon is clicked.
 * Two quick "zip zip" bursts, ~360ms total, then calls onComplete.
 */
export function GlitchOverlay({ onComplete }: Props) {
  useEffect(() => {
    const timer = setTimeout(onComplete, 360);
    return () => clearTimeout(timer);
  }, [onComplete]);

  return <div className="glitch-screen" aria-hidden="true" />;
}
